/**
 * The assistant floats above the app's own chrome. Anything it opens — a select
 * dropdown, a tooltip — portals to `document.body` at Mantine's default 300 and
 * would land behind the window, so it has to clear this explicitly.
 */
export const ASSISTANT_Z_INDEX = 401;
export const ASSISTANT_POPOVER_Z_INDEX = ASSISTANT_Z_INDEX + 1;
